module.exports = __webpack_public_path__ + "static/media/8-1.0ab80903.mp3";